import { IUserAccessDataRow } from "./AccessUserAccessesService";
import { IAccessRelationData, IRolePerrmission, IAccessRelationRawData } from "./AccessDomainModels";
import { RequestControl } from '../Relations/RequestControl';

export class AccessCheckExcludedRolePermissions {
	currentUserAccesses: IUserAccessDataRow[];
	table: RequestControl;

	constructor(table: RequestControl, currentUserAccesses: IUserAccessDataRow[]) {
		this.table = table;
		this.currentUserAccesses = currentUserAccesses;
	}

	checkExcludedRolePermissions(role: IRolePerrmission, itemsToPush?: IAccessRelationRawData[]): string[] {
		let result: string[] = [];
		if (!role) {
			return result;
		}
		if (!role.excludedRolePermissions) {
			return result;
		}
		for (let i = 0; i < role.excludedRolePermissions.length; i++) {
			let excludedRoleId = role.excludedRolePermissions[i];

			if (this.currentUserAccesses) {
				for (let j = 0; j < this.currentUserAccesses.length; j++) {
					let currentUserAccesse = this.currentUserAccesses[j];
					if (currentUserAccesse.role && currentUserAccesse.role.id == excludedRoleId) {
						result.push(currentUserAccesse.role.name);
					}
				}
			}

			if (this.table) {
				var tableRows = this.table.getRows<IAccessRelationData>();

				for (let j = 0; j < tableRows.length; j++) {
					let tableRow = tableRows[j];
					if (!tableRow.deleted && tableRow.role && tableRow.role.id == excludedRoleId) {
						result.push(tableRow.role.name);
					}
				}
			}

			if (itemsToPush) {

				for (let j = 0; j < itemsToPush.length; j++) {
					let item = itemsToPush[j];
					if (item.role && item.role.id == excludedRoleId) {
						result.push(item.role.name);
					}
				}
			}
		}

		return result;
	}
}

